import * as React from "react";
import "./OtsEventCard.scss";
import "@alaskaairux/auro-icon";
import dayjs from "dayjs";
import "../../theme/styles.css";
import "./OtsDashboardGrid.scss";
import TimeAlert from "./TimeAlert";
import { Tooltip, withStyles } from "@material-ui/core";
import FlightPathModal from "../Modal/FlightPathModal";
import * as DropdownConstant from "../../constants/DropdownConstants";
import { useDispatch } from "react-redux";
import { OtsAircraft } from "../../Models/OtsAircraft";
import { showFlightSchedule } from "../../store/feature/OpenEventsListSlice";
import { viewflightSchedule } from "../../store/feature/FlightScheduleSlice";
import { IsAuthorized, useAuthorization } from "meportal/AuthorizationProvider";
import {
  AccessEditButton,
  FlightScheduleButton,
  AccessTimeline,
} from "../../constants/PermissionSet";
import RealtimeHoursOpen from "../OpenEvents/RealTimeHoursOpen";
import ACHistoryButton from "../OpenEvents/ACHistoryButton";
import EllipsisTooltip from "../../helpers/EllipsisTooltip";
import CustomHtmlTooltip from "../../helpers/CustomHtmlTooltip";
import { getAirborneLabelMessage } from "./Common/AirborneLabelMessage";

interface OtsEventProps {
  otsEvent: OtsAircraft;
  onCardClick?: (otsEvent: OtsAircraft) => void;
  onEditClick?: (otsEvent: OtsAircraft) => void;
  onButtonClick?: any;
}

const formatTime = (inputTime: string, isTime: boolean) => {
  const convertedTime = dayjs.utc(inputTime).local();
  // dividing the input time into two components, date and time.
  if (isTime) {
    return convertedTime.format("HH:mm");
  } else {
    return convertedTime.format("MM/DD/YY");
  }
};
const formatTimeLocal = (inputTime: string, isTime: boolean) => {
  const convertedTime = dayjs(inputTime);
  // dividing the input time into two components, date and time.
  if (isTime) {
    return convertedTime.format("HH:mm");
  } else {
    return convertedTime.format("MM/DD/YY");
  }
};
const formatStationTime = (inputTime: string): string => {
  const convertedTime = dayjs(inputTime);
  return convertedTime.format("HH:mm");
};

const OtsEventCardTile: React.FC<OtsEventProps> = ({
  otsEvent,
  onCardClick,
  onEditClick,
  onButtonClick,
}) => {
  const NOT_APPLICABLE = "NotApplicable";
  const dispatch = useDispatch();
  const { eventPermissions, userClaims } = useAuthorization();
  const [IsDiversion, setIsDiversion] = React.useState<boolean>(false);
  const [airborneMessage, setAirborneMessage] = React.useState<string>("");
  const handleCardClick = (
    event:
      | React.MouseEvent<HTMLDivElement>
      | React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (
      onCardClick && onEditClick &&
      otsEvent.id
    ) {
      onButtonClick(null);
      //if user has edit permission then goto edit-ots page
      let okEdit = IsAuthorized(
        otsEvent.Airline + ":" + otsEvent.EventType,
        AccessEditButton,
        eventPermissions,
        userClaims
      );
      if(okEdit) {
        onEditClick(otsEvent);
        return;
      }
      //if user has timeline permission then goto event details page
      let okTimeline = IsAuthorized(
        otsEvent.Airline + ":" + otsEvent.EventType,
        AccessTimeline,
        eventPermissions,
        userClaims
      );
      if (okTimeline) {
        onCardClick(otsEvent);
        return;
      }
    }
  };

  React.useEffect(() => {
    if ( otsEvent?.IsAirborneAtCreate &&
        otsEvent?.EventTypeCategory === NOT_APPLICABLE
      ) {
        const {label, isDiversion} = getAirborneLabelMessage(otsEvent);
        setAirborneMessage(label);
        setIsDiversion(isDiversion);
      }
      else{
        setAirborneMessage("");
        setIsDiversion(false);
      }
  }, [otsEvent.IsAirborneAtCreate]);

  const FerryFlightHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (onCardClick) {
      onButtonClick("ferryFlight");
      onCardClick(otsEvent);
    }
  };

  const attachmentHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (onCardClick && otsEvent.id) {
      onButtonClick("attachment");
      onCardClick(otsEvent);
    }
  };
  const handleFieldTrip = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (onCardClick) {
      onButtonClick("fieldTrip");
      onCardClick(otsEvent);
    }
  };
  const handleFlightPathClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    dispatch(viewflightSchedule([]));
    dispatch(showFlightSchedule(otsEvent.AircraftRegistration));
  };

  const enableAttachmentButton = () => {
    if (
      IsAuthorized(
        otsEvent.Airline + ":" + otsEvent.EventType,
        AccessTimeline,
        eventPermissions,
        userClaims
      ) === false
    ) {
      return false;
    }
    return otsEvent?.HasPublicAttachment;
  };
  const specialEventChecker = (info: string) => {
    if (
      IsAuthorized(
        otsEvent.Airline + ":" + otsEvent.EventType,
        AccessTimeline,
        eventPermissions,
        userClaims
      ) === false
    ) {
      return false;
    }

    let data = otsEvent?.SpecialEventHistory;
    if (data != null) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].SpecialEventType === info) {
          return true;
        }
      }
    }
    return false;
  };
  const handleFlightPathCloseModalClick = () => {
    dispatch(showFlightSchedule(otsEvent.AircraftRegistration));
    dispatch(viewflightSchedule([]));
  };

  return (
    <React.Fragment>
      <div
        className="ots-sub-container"
        onClick={handleCardClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (
            e.key === "Enter"
          ) {
            handleCardClick(e);
          }
        }}
      >
        <div className="ots-card-container">
          <div className="ots-header-grid">
            <div className="ots-title-section-1">
              <div
                className={
                  otsEvent?.IsEtopsCapable === "true"
                    ? "ots-aircraft-section-etops"
                    : "ots-aircraft-section"
                }
              >
                <div className="ots-aircraft">
                  {otsEvent?.AircraftRegistration}
                </div>
                <div className="vl"></div>
                <div className="ots-station">{otsEvent?.Station}</div>
                <div className="flight-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M20 14.9833V12.9833L11.4883 8.49525L11.4883 3.33325C11.4883 3.33325 11.4883 0.333251 10 0.333251C8.51064 0.333251 8.51064 3.33325 8.51064 3.33325L8.51064 8.49525L0 12.9833L0 14.9833L8.51064 12.4953V16.0823L6.38192 18.3333V20.3333L9.99894 18.7323L13.617 20.3333V18.3333L11.4883 16.0823V12.4953L20 14.9833Z"
                      fill={
                        otsEvent?.IsEtopsCapable === "true"
                          ? "#068A1E"
                          : "#00274A"
                      }
                    />
                  </svg>
                </div>
                <div className="eta-div-in">
                  <span className={IsDiversion?"diversion-label":"eta-label"}>{airborneMessage}</span>
                </div>
              </div>
              <div className="ots-notification-part">
                <div className="notification-icon">
                <div className="button-container">
                <ACHistoryButton airline={otsEvent?.Airline} aircraftRegistration={otsEvent?.AircraftRegistration}/> 
                 </div>
                </div>
              </div>
            </div>

            <div className="ots-problem-section">
              <span>{otsEvent?.ProblemText}</span>
            </div>
          </div>
          <div className="ots-middle-section">
            <div className="ots-action-section">
              <div className="ots-action-buttons">
                <div className="ots-info-section ots-info-container-padding">
                  <div className="ots-info-container">
                    <div className="ots-action-button-section">
                      <div className="ots-action-container">
                        <div className="ots-etops-section etops-padding">
                          <TimeAlert
                            ADVBump={otsEvent.ADVBump}
                            AdviseTimeUTC={otsEvent.AdviseTimeUTC}
                            EstimatedReturnToServiceTimeUTC={
                              otsEvent.EstimatedReturnToServiceTimeUTC
                            }
                            ETRBump={otsEvent.ETRBump}
                            compName=""
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ots-action-buttons">
                      <div className="ots-action-container">
                        <div className="ots-etops-section">
                          <div className="ots-label-section">
                            <div className="ots-label-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  d="M8 3.45825C6.83804 3.45825 5.70217 3.80281 4.73603 4.44837C3.76989 5.09392 3.01688 6.01147 2.57221 7.08499C2.12755 8.1585 2.0112 9.33977 2.23789 10.4794C2.46458 11.619 3.02412 12.6659 3.84575 13.4875C4.66738 14.3091 5.71421 14.8687 6.85385 15.0954C7.99349 15.3221 9.17475 15.2057 10.2483 14.761C11.3218 14.3164 12.2393 13.5634 12.8849 12.5972C13.5304 11.6311 13.875 10.4952 13.875 9.33325C13.8732 7.77566 13.2536 6.28239 12.1522 5.18101C11.0509 4.07963 9.55759 3.46007 8 3.45825ZM8 14.4583C6.98637 14.4583 5.99551 14.1577 5.1527 13.5945C4.3099 13.0314 3.65302 12.231 3.26512 11.2945C2.87722 10.358 2.77573 9.32757 2.97348 8.33341C3.17123 7.33926 3.65934 6.42607 4.37608 5.70933C5.09282 4.99259 6.00601 4.50448 7.00016 4.30673C7.99432 4.10898 9.02478 4.21047 9.96126 4.59837C10.8977 4.98627 11.6981 5.64315 12.2613 6.48595C12.8244 7.32876 13.125 8.31962 13.125 9.33325C13.1233 10.692 12.5829 11.9946 11.6221 12.9553C10.6613 13.9161 9.35873 14.4566 8 14.4583ZM10.765 6.56825C10.8352 6.63856 10.8747 6.73388 10.8747 6.83325C10.8747 6.93263 10.8352 7.02794 10.765 7.09825L8.265 9.59825C8.23067 9.6351 8.18927 9.66465 8.14327 9.68514C8.09727 9.70564 8.04762 9.71666 7.99726 9.71755C7.94691 9.71844 7.8969 9.70917 7.8502 9.69031C7.80351 9.67145 7.76109 9.64338 7.72548 9.60777C7.68987 9.57216 7.6618 9.52974 7.64294 9.48305C7.62408 9.43636 7.61482 9.38634 7.61571 9.33599C7.6166 9.28564 7.62762 9.23598 7.64811 9.18998C7.66861 9.14398 7.69816 9.10258 7.735 9.06825L10.235 6.56825C10.3053 6.49803 10.4006 6.45858 10.5 6.45858C10.5994 6.45858 10.6947 6.49803 10.765 6.56825ZM6.125 1.83325C6.125 1.7338 6.16451 1.63841 6.23484 1.56809C6.30516 1.49776 6.40055 1.45825 6.5 1.45825H9.5C9.59946 1.45825 9.69484 1.49776 9.76517 1.56809C9.83549 1.63841 9.875 1.7338 9.875 1.83325C9.875 1.93271 9.83549 2.02809 9.76517 2.09842C9.69484 2.16874 9.59946 2.20825 9.5 2.20825H6.5C6.40055 2.20825 6.30516 2.16874 6.23484 2.09842C6.16451 2.02809 6.125 1.93271 6.125 1.83325Z"
                                  fill="#8093A4"
                                />
                              </svg>
                            </div>
                            <div className="ots-label-text">ETD:</div>
                          </div>
                          {otsEvent.SETD ? (
                            <div className="ots-label-value-section value-etdsection">
                              <span className="time-span">
                                {formatTimeLocal(otsEvent.SETD, true)}
                              </span>
                              <span>
                                {formatTimeLocal(otsEvent.SETD, false)}
                              </span>
                            </div>
                          ) : (
                            <div className="ots-label-value-section">
                              Unrouted
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="ots-action-buttons">
                      <div className="ots-action-container">
                        <div className="ots-etops-section">
                          <div className="ots-label-section">
                            <div className="ots-label-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  d="M7.99829 7.9865C8.29518 7.9865 8.54851 7.88095 8.75829 7.66984C8.96807 7.45873 9.07296 7.20473 9.07296 6.90784C9.07296 6.61095 8.9674 6.35761 8.75629 6.14784C8.54474 5.93806 8.29074 5.83317 7.99429 5.83317C7.69785 5.83317 7.44451 5.93895 7.23429 6.1505C7.02451 6.36161 6.91963 6.61561 6.91963 6.9125C6.91963 7.20939 7.02518 7.46273 7.23629 7.6725C7.44785 7.88228 7.70185 7.98717 7.99829 7.98717M7.99629 13.2845C9.24963 12.1938 10.2403 11.0847 10.9683 9.95717C11.6963 8.82917 12.0603 7.85361 12.0603 7.0305C12.0603 5.81095 11.6743 4.80428 10.9023 4.0105C10.1303 3.21673 9.16163 2.82006 7.99629 2.8205C6.8314 2.8205 5.86274 3.21717 5.09029 4.0105C4.31785 4.80384 3.93185 5.8105 3.93229 7.0305C3.93229 7.85361 4.29629 8.82917 5.02429 9.95717C5.75274 11.0847 6.7434 12.1943 7.99629 13.2845ZM7.99629 14.1792C6.42963 12.7938 5.24963 11.5018 4.45629 10.3032C3.66251 9.1045 3.26562 8.01361 3.26562 7.0305C3.26562 5.62028 3.72474 4.45717 4.64296 3.54117C5.56163 2.62473 6.6794 2.1665 7.99629 2.1665C9.31318 2.1665 10.431 2.62473 11.3496 3.54117C12.2678 4.45717 12.727 5.62028 12.727 7.0305C12.727 8.01361 12.3303 9.1045 11.537 10.3032C10.7432 11.5018 9.56296 12.7938 7.99629 14.1792Z"
                                  fill="#8093A4"
                                />
                              </svg>
                            </div>
                            <div className="ots-label-text">Loc:</div>
                          </div>
                          <div className="ots-label-value-section">
                            {" "}
                            {otsEvent?.Location !== "" ? (
                              <span>{otsEvent?.Location}</span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ots-action-buttons">
                      <div className="ots-action-container">
                        <div className="ots-etops-section">
                          <div className="ots-label-section">
                            <div className="ots-label-icon">
                              {/* Time open icon : Keeping if business wanna go to this again */}
                              {/* <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="ph:timer-light">
                                  <path
                                    id="Vector"
                                    d="M8 3.125C6.83804 3.125 5.70217 3.46956 4.73603 4.11512C3.76989 4.76067 3.01688 5.67822 2.57221 6.75173C2.12755 7.82525 2.0112 9.00652 2.23789 10.1462C2.46458 11.2858 3.02412 12.3326 3.84575 13.1543C4.66738 13.9759 5.71421 14.5354 6.85385 14.7621C7.99349 14.9888 9.17475 14.8725 10.2483 14.4278C11.3218 13.9831 12.2393 13.2301 12.8849 12.264C13.5304 11.2978 13.875 10.162 13.875 9C13.8732 7.44241 13.2536 5.94914 12.1522 4.84776C11.0509 3.74638 9.55759 3.12682 8 3.125ZM8 14.125C6.98637 14.125 5.99551 13.8244 5.1527 13.2613C4.3099 12.6981 3.65302 11.8977 3.26512 10.9613C2.87722 10.0248 2.77573 8.99431 2.97348 8.00016C3.17123 7.00601 3.65934 6.09282 4.37608 5.37608C5.09282 4.65933 6.00601 4.17122 7.00016 3.97348C7.99432 3.77573 9.02478 3.87722 9.96126 4.26512C10.8977 4.65302 11.6981 5.3099 12.2613 6.1527C12.8244 6.9955 13.125 7.98637 13.125 9C13.1233 10.3587 12.5829 11.6613 11.6221 12.6221C10.6613 13.5829 9.35873 14.1233 8 14.125ZM10.765 6.235C10.8352 6.30531 10.8747 6.40062 10.8747 6.5C10.8747 6.59938 10.8352 6.69469 10.765 6.765L8.265 9.265C8.23067 9.30184 8.18927 9.33139 8.14327 9.35189C8.09727 9.37239 8.04762 9.38341 7.99726 9.3843C7.94691 9.38518 7.8969 9.37592 7.8502 9.35706C7.80351 9.3382 7.76109 9.31013 7.72548 9.27452C7.68987 9.23891 7.6618 9.19649 7.64294 9.1498C7.62408 9.1031 7.61482 9.05309 7.61571 9.00274C7.6166 8.95239 7.62762 8.90273 7.64811 8.85673C7.66861 8.81073 7.69816 8.76933 7.735 8.735L10.235 6.235C10.3053 6.16477 10.4006 6.12533 10.5 6.12533C10.5994 6.12533 10.6947 6.16477 10.765 6.235ZM6.125 1.5C6.125 1.40054 6.16451 1.30516 6.23484 1.23483C6.30516 1.16451 6.40055 1.125 6.5 1.125H9.5C9.59946 1.125 9.69484 1.16451 9.76517 1.23483C9.83549 1.30516 9.875 1.40054 9.875 1.5C9.875 1.59946 9.83549 1.69484 9.76517 1.76517C9.69484 1.83549 9.59946 1.875 9.5 1.875H6.5C6.40055 1.875 6.30516 1.83549 6.23484 1.76517C6.16451 1.69484 6.125 1.59946 6.125 1.5Z"
                                    fill="#73889C"
                                  />
                                </g>
                              </svg> */}
                              <svg xmlns="http://www.w3.org/2000/svg"
                                width="16"height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  d="M14 8.50007C14.002 9.69125 13.6477 10.8558 12.9827 11.8441C12.4342 12.662 11.6927 13.3323 10.8237 13.7955C9.95461 14.2588 8.98481 14.5008 8 14.5001C7.01519 14.5008 6.04539 14.2588 5.17634 13.7955C4.30729 13.3323 3.56576 12.662 3.01733 11.8441C2.49515 11.0657 2.1626 10.1758 2.04634 9.2457C1.93007 8.31562 2.03333 7.37124 2.34783 6.48826C2.66233 5.60528 3.17933 4.80827 3.85738 4.16111C4.53543 3.51395 5.35566 3.03465 6.25234 2.76163C7.14901 2.48861 8.09718 2.42947 9.02083 2.58894C9.94448 2.74842 10.8179 3.12207 11.5711 3.67995C12.3244 4.23783 12.9364 4.96442 13.3582 5.80148C13.78 6.63853 13.9998 7.56276 14 8.50007Z" stroke="#8093A4"/><path
                                  d="M8.99765 6.50016C8.99765 6.76538 8.89229 7.01973 8.70475 7.20727C8.51722 7.39481 8.26286 7.50016 7.99765 7.50016V8.16683C8.21652 8.16683 8.43324 8.12372 8.63545 8.03996C8.83766 7.9562 9.02139 7.83344 9.17616 7.67867C9.33092 7.52391 9.45369 7.34018 9.53744 7.13797C9.6212 6.93576 9.66431 6.71903 9.66431 6.50016H8.99765ZM7.99765 7.50016C7.73243 7.50016 7.47808 7.39481 7.29054 7.20727C7.103 7.01973 6.99765 6.76538 6.99765 6.50016H6.33098C6.33098 6.71903 6.37409 6.93576 6.45785 7.13797C6.5416 7.34018 6.66437 7.52391 6.81913 7.67867C7.13169 7.99123 7.55562 8.16683 7.99765 8.16683V7.50016ZM6.99765 6.50016C6.99765 6.23495 7.103 5.98059 7.29054 5.79306C7.47808 5.60552 7.73243 5.50016 7.99765 5.50016V4.8335C7.55562 4.8335 7.13169 5.00909 6.81913 5.32165C6.50657 5.63421 6.33098 6.05814 6.33098 6.50016H6.99765ZM7.99765 5.50016C8.26286 5.50016 8.51722 5.60552 8.70475 5.79306C8.89229 5.98059 8.99765 6.23495 8.99765 6.50016H9.66431C9.66431 6.05814 9.48872 5.63421 9.17616 5.32165C8.8636 5.00909 8.43967 4.8335 7.99765 4.8335V5.50016ZM3.44165 12.4042L3.12165 12.3095L3.07031 12.4835L3.18831 12.6215L3.44165 12.4042ZM12.5536 12.4042L12.807 12.6215L12.925 12.4835L12.873 12.3095L12.5536 12.4042ZM5.99765 10.8335H9.99765V10.1668H5.99765V10.8335ZM5.99765 10.1668C5.3516 10.1669 4.72284 10.3755 4.20481 10.7615C3.68678 11.1476 3.30648 11.6905 3.12165 12.3095L3.76098 12.4995C3.90488 12.0181 4.20026 11.596 4.60321 11.2958C5.00616 10.9957 5.49519 10.8335 5.99765 10.8335V10.1668ZM7.99765 14.1668C7.17982 14.1677 6.37155 13.9911 5.6286 13.6493C4.88564 13.3074 4.2257 12.8085 3.69431 12.1868L3.18831 12.6215C3.78235 13.316 4.51994 13.8734 5.35022 14.2553C6.18051 14.6372 7.08375 14.8344 7.99765 14.8335V14.1668ZM9.99765 10.8335C10.5002 10.8336 10.9893 10.9958 11.3922 11.2961C11.7952 11.5964 12.0905 12.0186 12.2343 12.5002L12.873 12.3095C12.6881 11.6905 12.3085 11.1476 11.7905 10.7615C11.2724 10.3755 10.6437 10.1669 9.99765 10.1668V10.8335ZM12.301 12.1868C11.7696 12.8085 11.1096 13.3074 10.3667 13.6493C9.62374 13.9911 8.81547 14.1677 7.99765 14.1668V14.8335C8.91154 14.8344 9.81478 14.6372 10.6451 14.2553C11.4754 13.8734 12.2129 13.316 12.807 12.6215L12.301 12.1868Z"
                                  fill="#8093A4"
                                />
                              </svg>
                            </div>
                            {/* TODO: Remove/Add RealTimeHoursOpen on card tile*/}
                            {/* <div className="ots-label-text">Time open:</div>
                          </div>
                          <EllipsisTooltip
                            title={
                              <RealtimeHoursOpen
                                outOfServiceDateTimeUTC={
                                  otsEvent?.OutOfServiceDateTimeUTC
                                }
                              />
                            }
                            placement="bottom"
                            className="customTooltip"
                          >
                            <div className="ots-label-value-section ots-controller-ellipsis">
                              <RealtimeHoursOpen
                                outOfServiceDateTimeUTC={
                                  otsEvent?.OutOfServiceDateTimeUTC
                                }
                                className="ots-label-value-section"
                              />
                            </div>
                          </EllipsisTooltip>
                        </div> */}
                            <div className="ots-label-text">Updated:</div>
                            </div>
                            <EllipsisTooltip
                                                        title={otsEvent.LastUpdatedBy}
                                                        placement="bottom"
                            >
                            <span className="ots-label-value-section updated-by ots-controller-ellipsis">
                                                          {otsEvent.LastUpdatedBy}
                            </span>
                            </EllipsisTooltip>
                            </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="action-btn-container">
                <button
                  className={
                    !IsAuthorized(
                      otsEvent.Airline + ":" + otsEvent.EventType,
                      FlightScheduleButton,
                      eventPermissions,
                      userClaims
                    )
                      ? "ots-button disable-btn"
                      : "ots-button"
                  }
                  onClick={handleFlightPathClick}
                >
                  <div className="ots-btn-label">
                    <span className="ots-button-icon">
                      {IsAuthorized(
                        otsEvent.Airline + ":" + otsEvent.EventType,
                        FlightScheduleButton,
                        eventPermissions,
                        userClaims
                      ) ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.5 12.1667L15 13.1667V12.1667L12.5 10.9167V9.66675C12.5 9.53414 12.4473 9.40696 12.3536 9.31319C12.2598 9.21943 12.1326 9.16675 12 9.16675C11.8674 9.16675 11.7402 9.21943 11.6464 9.31319C11.5527 9.40696 11.5 9.53414 11.5 9.66675V10.9167L9 12.1667V13.1667L11.5 12.1667V13.9167L10.5 14.6667V15.1667L12 14.6667L13.5 15.1667V14.6667L12.5 13.9167V12.1667Z"
                            fill="#0074C8"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13 2.66675H11V1.66675H10V2.66675H6V1.66675H5V2.66675H3C2.73478 2.66675 2.48043 2.7721 2.29289 2.95964C2.10536 3.14718 2 3.40153 2 3.66675V13.6667C2 13.932 2.10536 14.1863 2.29289 14.3739C2.48043 14.5614 2.73478 14.6667 3 14.6667H8V13.6667H3V3.66675H5V4.66675H6V3.66675H10V4.66675H11V3.66675H13V7.16675H14V3.66675C14 3.40153 13.8946 3.14718 13.7071 2.95964C13.5196 2.7721 13.2652 2.66675 13 2.66675Z"
                            fill="#0074C8"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.5 12.1667L15 13.1667V12.1667L12.5 10.9167V9.66675C12.5 9.53414 12.4473 9.40696 12.3536 9.31319C12.2598 9.21943 12.1326 9.16675 12 9.16675C11.8674 9.16675 11.7402 9.21943 11.6464 9.31319C11.5527 9.40696 11.5 9.53414 11.5 9.66675V10.9167L9 12.1667V13.1667L11.5 12.1667V13.9167L10.5 14.6667V15.1667L12 14.6667L13.5 15.1667V14.6667L12.5 13.9167V12.1667Z"
                            fill="#979798"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13 2.66675H11V1.66675H10V2.66675H6V1.66675H5V2.66675H3C2.73478 2.66675 2.48043 2.7721 2.29289 2.95964C2.10536 3.14718 2 3.40153 2 3.66675V13.6667C2 13.932 2.10536 14.1863 2.29289 14.3739C2.48043 14.5614 2.73478 14.6667 3 14.6667H8V13.6667H3V3.66675H5V4.66675H6V3.66675H10V4.66675H11V3.66675H13V7.16675H14V3.66675C14 3.40153 13.8946 3.14718 13.7071 2.95964C13.5196 2.7721 13.2652 2.66675 13 2.66675Z"
                            fill="#979798"
                          />
                        </svg>
                      )}
                    </span>
                    {/* */}
                    Flt sched.
                  </div>
                </button>
                <button
                  className={
                    specialEventChecker(DropdownConstant.FERRY_FLIGHT)
                      ? "ots-button"
                      : "ots-button disable-btn"
                  }
                  onClick={FerryFlightHandler}
                >
                  <div className="ots-btn-label">
                    <span className="ots-button-icon">
                      {specialEventChecker(DropdownConstant.FERRY_FLIGHT) ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_1505_124691)">
                            <path
                              d="M1.02071 15.5071H16.0109V17.085H1.02071V15.5071ZM16.4606 8.12246C16.2949 7.49129 15.6401 7.11259 15.0089 7.28616L10.8195 8.40648L5.37575 3.3335L3.85306 3.73586L7.11934 9.39268L3.19823 10.442L1.64399 9.227L0.5 9.53469L2.5434 13.0771C2.5434 13.0771 8.16076 11.5781 15.6164 9.58203C16.2554 9.40057 16.6263 8.75362 16.4606 8.12246Z"
                              fill="#0074C8"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1505_124691">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0.5 0.666748)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="ic:baseline-flight-takeoff"
                            clipPath="url(#clip0_2130_108476)"
                          >
                            <path
                              id="Vector"
                              d="M1.02071 15.6736H16.0109V17.2515H1.02071V15.6736ZM16.4606 8.28896C16.2949 7.6578 15.6401 7.2791 15.0089 7.45267L10.8195 8.57299L5.37575 3.5L3.85306 3.90237L7.11934 9.55918L3.19823 10.6085L1.64399 9.3935L0.5 9.70119L2.5434 13.2436C2.5434 13.2436 8.16076 11.7446 15.6164 9.74853C16.2554 9.56707 16.6263 8.92013 16.4606 8.28896Z"
                              fill="#979798"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2130_108476">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0.5 0.833252)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </span>
                    {/* */}
                    Spec flt per.
                  </div>
                </button>
                <button
                  className={
                    enableAttachmentButton()
                      ? "ots-button"
                      : "ots-button disable-btn"
                  }
                  onClick={attachmentHandler}
                >
                  <div className="ots-btn-label">
                    <span className="ots-button-icon">
                      {enableAttachmentButton() ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_1505_124684)">
                            <path
                              d="M14.0859 9.41648L9.61372 13.8887C9.20116 14.3013 8.64161 14.533 8.05816 14.533C7.47471 14.533 6.91516 14.3013 6.5026 13.8887C6.09005 13.4761 5.85827 12.9166 5.85827 12.3331C5.85827 11.7497 6.09005 11.1901 6.5026 10.7776L11.3637 5.91648C11.6216 5.65863 11.9713 5.51377 12.3359 5.51377C12.7006 5.51377 13.0503 5.65863 13.3082 5.91648C13.566 6.17433 13.7109 6.52404 13.7109 6.8887C13.7109 7.25335 13.566 7.60307 13.3082 7.86092L9.22483 11.9443C9.12169 12.0474 8.9818 12.1053 8.83594 12.1053C8.69008 12.1053 8.55019 12.0474 8.44705 11.9443C8.34391 11.8411 8.28597 11.7012 8.28597 11.5554C8.28597 11.4095 8.34391 11.2696 8.44705 11.1665L12.1415 7.47203L11.5582 6.8887L7.86372 10.5831C7.60587 10.841 7.46101 11.1907 7.46101 11.5554C7.46101 11.92 7.60587 12.2697 7.86372 12.5276C8.12156 12.7854 8.47128 12.9303 8.83594 12.9303C9.20059 12.9303 9.55031 12.7854 9.80816 12.5276L13.8915 8.44425C14.3041 8.0317 14.5358 7.47215 14.5358 6.8887C14.5358 6.30525 14.3041 5.7457 13.8915 5.33314C13.4789 4.92058 12.9194 4.68881 12.3359 4.68881C11.7525 4.68881 11.1929 4.92058 10.7804 5.33314L5.91927 10.1943C5.352 10.7615 5.03331 11.5309 5.03331 12.3331C5.03331 13.1354 5.352 13.9048 5.91927 14.472C6.48654 15.0393 7.25592 15.358 8.05816 15.358C8.8604 15.358 9.62978 15.0393 10.197 14.472L14.6693 9.99981L14.0859 9.41648Z"
                              fill="#0074C8"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1505_124684">
                              <rect
                                width="13.1993"
                                height="13.1993"
                                fill="white"
                                transform="translate(10 0.666748) rotate(45)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="mdi:attachment-vertical"
                            clipPath="url(#clip0_2148_107048)"
                          >
                            <path
                              id="Vector"
                              d="M14.0859 9.24973L9.61372 13.722C9.20116 14.1345 8.64161 14.3663 8.05816 14.3663C7.47471 14.3663 6.91516 14.1345 6.5026 13.722C6.09005 13.3094 5.85827 12.7498 5.85827 12.1664C5.85827 11.5829 6.09005 11.0234 6.5026 10.6108L11.3637 5.74973C11.6216 5.49188 11.9713 5.34702 12.3359 5.34702C12.7006 5.34702 13.0503 5.49188 13.3082 5.74973C13.566 6.00758 13.7109 6.3573 13.7109 6.72195C13.7109 7.0866 13.566 7.43632 13.3082 7.69417L9.22483 11.7775C9.12169 11.8806 8.9818 11.9386 8.83594 11.9386C8.69008 11.9386 8.55019 11.8806 8.44705 11.7775C8.34391 11.6744 8.28597 11.5345 8.28597 11.3886C8.28597 11.2428 8.34391 11.1029 8.44705 10.9997L12.1415 7.30528L11.5582 6.72195L7.86372 10.4164C7.60587 10.6742 7.46101 11.024 7.46101 11.3886C7.46101 11.7533 7.60587 12.103 7.86372 12.3608C8.12156 12.6187 8.47128 12.7635 8.83594 12.7635C9.20059 12.7635 9.55031 12.6187 9.80816 12.3608L13.8915 8.27751C14.3041 7.86495 14.5358 7.3054 14.5358 6.72195C14.5358 6.1385 14.3041 5.57895 13.8915 5.1664C13.4789 4.75384 12.9194 4.52206 12.3359 4.52206C11.7525 4.52206 11.1929 4.75384 10.7804 5.1664L5.91927 10.0275C5.352 10.5948 5.03331 11.3642 5.03331 12.1664C5.03331 12.9686 5.352 13.738 5.91927 14.3053C6.48654 14.8726 7.25592 15.1912 8.05816 15.1912C8.8604 15.1912 9.62978 14.8726 10.197 14.3053L14.6693 9.83306L14.0859 9.24973Z"
                              fill="#979798"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2148_107048">
                              <rect
                                width="13.1993"
                                height="13.1993"
                                fill="white"
                                transform="translate(10 0.5) rotate(45)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </span>
                    {/* */}
                    Attach.
                  </div>
                </button>
                <button
                  className={
                    specialEventChecker(DropdownConstant.FIELD_TRIP)
                      ? "ots-button"
                      : "ots-button disable-btn "
                  }
                  onClick={handleFieldTrip}
                >
                  <div className="ots-btn-label">
                    <span className="ots-button-icon">
                      {specialEventChecker(DropdownConstant.FIELD_TRIP) ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="14"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M10.7759 14.4H4.10026C2.99698 14.4 2.10011 13.5032 2.10011 12.4C2.10011 11.2968 2.99698 10.4 4.10026 10.4H9.70065C11.2448 10.4 12.5009 9.144 12.5009 7.6C12.5009 6.056 11.2448 4.8 9.70065 4.8H5.81158C5.51776 5.37591 5.15391 5.91331 4.7283 6.4H9.70065C10.3623 6.4 10.9007 6.9384 10.9007 7.6C10.9007 8.2616 10.3623 8.8 9.70065 8.8H4.10026C2.11531 8.8 0.5 10.4152 0.5 12.4C0.5 14.3848 2.11531 16 4.10026 16H11.7752C11.3826 15.5062 11.0474 14.9694 10.7759 14.4ZM2.90017 0C1.57688 0 0.5 1.0768 0.5 2.4C0.5 4.9504 2.90017 6.4 2.90017 6.4C2.90017 6.4 5.30034 4.9496 5.30034 2.4C5.30034 1.0768 4.22346 0 2.90017 0ZM2.90017 3.6C2.74252 3.59995 2.58642 3.56885 2.4408 3.50847C2.29517 3.4481 2.16285 3.35963 2.05142 3.24813C1.93998 3.13662 1.8516 3.00426 1.79131 2.8586C1.73103 2.71294 1.70003 2.55684 1.70009 2.3992C1.70014 2.24156 1.73124 2.08548 1.79162 1.93986C1.852 1.79424 1.94047 1.66194 2.05198 1.55051C2.16349 1.43908 2.29586 1.3507 2.44153 1.29042C2.5872 1.23014 2.74332 1.19915 2.90097 1.1992C3.21936 1.19931 3.52466 1.32588 3.74972 1.55107C3.97478 1.77627 4.10116 2.08163 4.10106 2.4C4.10095 2.71837 3.97437 3.02365 3.74916 3.24869C3.52395 3.47374 3.21856 3.60011 2.90017 3.6Z"
                            fill="#0074C8"
                          />
                          <path
                            d="M14.1033 9.6001C12.78 9.6001 11.7031 10.6769 11.7031 12.0001C11.7031 14.5505 14.1033 16.0001 14.1033 16.0001C14.1033 16.0001 16.5035 14.5497 16.5035 12.0001C16.5035 10.6769 15.4266 9.6001 14.1033 9.6001ZM14.1033 13.2001C13.9456 13.2 13.7895 13.1689 13.6439 13.1086C13.4983 13.0482 13.366 12.9597 13.2545 12.8482C13.1431 12.7367 13.0547 12.6044 12.9944 12.4587C12.9342 12.313 12.9032 12.1569 12.9032 11.9993C12.9033 11.8417 12.9344 11.6856 12.9947 11.54C13.0551 11.3943 13.1436 11.262 13.2551 11.1506C13.3666 11.0392 13.499 10.9508 13.6447 10.8905C13.7903 10.8302 13.9464 10.7992 14.1041 10.7993C14.4225 10.7994 14.7278 10.926 14.9528 11.1512C15.1779 11.3764 15.3043 11.6817 15.3042 12.0001C15.3041 12.3185 15.1775 12.6237 14.9523 12.8488C14.7271 13.0738 14.4217 13.2002 14.1033 13.2001Z"
                            fill="#0074C8"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Group 3704">
                            <path
                              id="Vector"
                              d="M10.7759 14.5667H4.10026C2.99698 14.5667 2.10011 13.6699 2.10011 12.5667C2.10011 11.4635 2.99698 10.5667 4.10026 10.5667H9.70065C11.2448 10.5667 12.5009 9.31066 12.5009 7.76666C12.5009 6.22266 11.2448 4.96666 9.70065 4.96666H5.81158C5.51776 5.54256 5.15391 6.07997 4.7283 6.56666H9.70065C10.3623 6.56666 10.9007 7.10506 10.9007 7.76666C10.9007 8.42826 10.3623 8.96666 9.70065 8.96666H4.10026C2.11531 8.96666 0.5 10.5819 0.5 12.5667C0.5 14.5515 2.11531 16.1667 4.10026 16.1667H11.7752C11.3826 15.6729 11.0474 15.1361 10.7759 14.5667ZM2.90017 0.166656C1.57688 0.166656 0.5 1.24346 0.5 2.56666C0.5 5.11706 2.90017 6.56666 2.90017 6.56666C2.90017 6.56666 5.30034 5.11626 5.30034 2.56666C5.30034 1.24346 4.22346 0.166656 2.90017 0.166656ZM2.90017 3.76666C2.74252 3.7666 2.58642 3.7355 2.4408 3.67513C2.29517 3.61475 2.16285 3.52629 2.05142 3.41478C1.93998 3.30328 1.8516 3.17092 1.79131 3.02526C1.73103 2.8796 1.70003 2.7235 1.70009 2.56586C1.70014 2.40822 1.73124 2.25213 1.79162 2.10651C1.852 1.96089 1.94047 1.82859 2.05198 1.71716C2.16349 1.60573 2.29586 1.51736 2.44153 1.45708C2.5872 1.3968 2.74332 1.3658 2.90097 1.36586C3.21936 1.36596 3.52466 1.49253 3.74972 1.71773C3.97478 1.94292 4.10116 2.24829 4.10106 2.56666C4.10095 2.88502 3.97437 3.19031 3.74916 3.41535C3.52395 3.64039 3.21856 3.76676 2.90017 3.76666Z"
                              fill="#979798"
                            />
                            <path
                              id="Vector_2"
                              d="M14.1033 9.76663C12.78 9.76663 11.7031 10.8434 11.7031 12.1666C11.7031 14.717 14.1033 16.1666 14.1033 16.1666C14.1033 16.1666 16.5035 14.7162 16.5035 12.1666C16.5035 10.8434 15.4266 9.76663 14.1033 9.76663ZM14.1033 13.3666C13.9456 13.3666 13.7895 13.3355 13.6439 13.2751C13.4983 13.2147 13.366 13.1263 13.2545 13.0148C13.1431 12.9033 13.0547 12.7709 12.9944 12.6252C12.9342 12.4796 12.9032 12.3235 12.9032 12.1658C12.9033 12.0082 12.9344 11.8521 12.9947 11.7065C13.0551 11.5609 13.1436 11.4286 13.2551 11.3171C13.3666 11.2057 13.499 11.1173 13.6447 11.0571C13.7903 10.9968 13.9464 10.9658 14.1041 10.9658C14.4225 10.9659 14.7278 11.0925 14.9528 11.3177C15.1779 11.5429 15.3043 11.8483 15.3042 12.1666C15.3041 12.485 15.1775 12.7903 14.9523 13.0153C14.7271 13.2404 14.4217 13.3667 14.1033 13.3666Z"
                              fill="#979798"
                            />
                          </g>
                        </svg>
                      )}
                    </span>
                    {/* */}
                    Field Trip
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FlightPathModal
        isOpen={otsEvent.ShowFlightSchedule}
        close={handleFlightPathCloseModalClick}
        aircraftNumber={otsEvent.AircraftRegistration}
        confirm={() => {}}
      />
    </React.Fragment>
  );
};
export default OtsEventCardTile;
